import { Controller } from '@hotwired/stimulus'


export default class extends Controller {
  toggle(e) {
    document.querySelector(e.currentTarget.dataset.target).classList.toggle('-show')
  }
}
